import {
    AnyImageOpResult,
    AnyImageOpResultNode,
    ValueOrNode,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpNodeReduce} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/reduce/node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {evaluateAndReadTexel} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/evaluate-and-read-texel"
import {ImageOpSystem} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-system"
import {ColorLike} from "@cm/math"

export type SourceMean = number | ColorLike

// Builds the live mean-reduction node — used both as ImageOpNodeOperatorGradientRemoval's fallback
// when the facade didn't eagerly supply sourceMean (node.ts) and internally by computeSourceMean
// below, so there's exactly one place that constructs this subgraph.
export function buildLiveSourceMean(imageOpNodeBag: ImageOpNodeBag, idPrefix: string, sourceImage: ValueOrNode<AnyImageOpResult>) {
    return imageOpNodeBag.getNode(`${idPrefix}Mean`, ImageOpNodeReduce, {sourceImage, operator: "mean"})
}

export async function computeSourceMean(imageOpSystem: ImageOpSystem, sourceImage: AnyImageOpResultNode): Promise<SourceMean> {
    const meanValues = await evaluateAndReadTexel(imageOpSystem, "computeSourceMean", (bag) => buildLiveSourceMean(bag, "computeSourceMean", sourceImage))
    switch (meanValues.length) {
        case 1:
            return meanValues[0]
        case 3:
            return {r: meanValues[0], g: meanValues[1], b: meanValues[2]}
        case 4:
            return {r: meanValues[0], g: meanValues[1], b: meanValues[2], a: meanValues[3]}
        default:
            throw new Error(`computeSourceMean: unsupported channel count ${meanValues.length}`)
    }
}
